/**
 * cyfunApi.ts - config du Rapport CyFun persistée côté client (backend) :
 *  - niveau cible (Basic/Important/Essential)
 *  - snapshot des dates de dernier scan par contrôle
 */
import { apiFetch } from './apiClient';
import { DEMO_MODE } from './liveMode';
import { demoCyfunConfig } from '../demo/demoData';

export interface CyFunScanSnapshotEntry {
  date?:        string;
  status?:      string;
  hasEvidence?: boolean;
}

export interface CyFunConfig {
  targetLevel:  string;
  scanSnapshot: Record<string, CyFunScanSnapshotEntry>;
}

export const cyfunApi = {
  getConfig: () => DEMO_MODE
    ? Promise.resolve(demoCyfunConfig())
    : apiFetch<CyFunConfig>('/clients/cyfun-config'),

  saveConfig: (body: { targetLevel?: string; scanSnapshot?: Record<string, CyFunScanSnapshotEntry> }) =>
    DEMO_MODE
      ? Promise.resolve({ saved: true, targetLevel: body.targetLevel ?? 'Important' })
      : apiFetch<{ saved: boolean; targetLevel?: string }>('/clients/cyfun-config', {
          method: 'POST',
          body: JSON.stringify(body),
        }),
};
